import { styled } from 'styled-components';
import { Modal } from '@interstate/components/Modal';

/**
 * This enables hiding a large non-configurable empty space added
 * as part of the FloatingFooter component in Interstate's Modal
 */
export const ModalHiddenFloatingFooter = styled(Modal)<{ isShowingCloseConfirmation?: boolean }>`
    ${({ isShowingCloseConfirmation }: any) =>
        isShowingCloseConfirmation &&
        `
        & .MuiDialogContent-root > .MuiBox-root {
            display: none;
        }
    `}
`;
